import styled from 'styled-components';
import {palette} from 'styled-theme';
import {Modal} from "antd";
import {SearchDirectoryStyles} from './SearchDirectory';
import { SearchGuideStyles } from './SearchGuide.styles';

const StyledModal = styled(Modal)`
  &.ant-modal {
    top: 60px;
    width: 75% !important;

    /* padding-bottom: 0; */

    @media only screen and (width <= 575px) {
      top: 60px;
      width: 95% !important;
    }
  }

  .ant-modal-close-x {
    display: none;
    width: 28px;
    height: 28px;
    line-height: 28px;
  }

  .ant-modal-content {
    padding: 0;
    overflow: hidden;
    border-radius: 5px;

    .ant-modal-header {
      display: none;
    }

    .ant-modal-body {
      padding: 0;

      .isoSearchContainer {
        border-bottom: 1px solid #e8e8e8;
        outline: 0;
        box-shadow: 0 0 4px 0 #ccc;

        .ant-input-search {
          .ant-input-wrapper {
            .ant-input-affix-wrapper {
              border: 0 !important;
              box-shadow: none !important;
            }

            .ant-input-prefix {
              margin-right: 16px;
              margin-left: 4px;
            }

            .ant-input {
              height: 48px;
              font-size: 14px;
              border: 0;
              border-radius: 0;

              &::placeholder {
                color: ${palette('grayscale', 0)};
              }
            }

            .ant-input-suffix > *:not(:last-child) {
              margin-right: 0;
              margin-left: 0;
            }
          }
        }

        .ant-input-group-addon {
          .ant-input-search-button {
            display: none;
          }
        }
      }

      ${SearchGuideStyles}
      ${SearchDirectoryStyles}

      .searchHintContainer {
        padding: 30px 25px;

        @media only screen and (width <= 575px) { /* xs */
          padding: 25px 20px;
        }

        p {
          padding-bottom: 8px;

          &:last-child {
            padding-bottom: 0;
          }
        }

        ul {
          padding: 0 12px;
          padding-top: 4px;

          li {
            padding: 4px;
          }
        }
      }

      .searchTransactions {
        p {
          padding: 16px 20px;
          text-align: center;
        }
      }
    }
  }
`;

export default StyledModal;
